import React, { useState } from "react";
import EmployAside from "../aside";
import CorbeilleGed from "./ged_corbeille";
const EmployDashboardSubmitJobPage = () => {
  const [isOpenSidebar,setIsOpenSidebar] = useState(false);
  return (    
    <div className="main-page-wrapper">
      <EmployAside isOpenSidebar={isOpenSidebar} setIsOpenSidebar={setIsOpenSidebar} />

      <CorbeilleGed setIsOpenSidebar={setIsOpenSidebar} />
    </div>    
  );
};

export default EmployDashboardSubmitJobPage;
